module.exports = __webpack_public_path__ + "je.svg?a2bead8f5c6abd826fe5b5e8c52901b4";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/je.svg
// module id = 1175
// module chunks = 0